@if (deviceService.isMobile && userService.isAuthenticated) {
    @if (!isDataLoaded) {
        <div class="toggle-loader">
            <div class="loader"></div>
        </div>
    } @else {
        <div class="toggle-navigation">
            <ds-segmented-control
                class="ds-segment-full-width"
                [twoLineTruncation]="false"
                [fullWidth]="true"
                [inverse]="true"
                [roleType]="'tablist'"
                [activeOption]="toggleNavigationService.isPromoActive ? 'offers' : 'rewards'"
                (activeOptionChange)="onToggleNavigation($event)">
                <ds-segmented-option name="offers" [title]="rewardsHubSegments?.promoHub" />
                <ds-segmented-option name="rewards" [title]="rewardsHubSegments?.rewardsHub" />
            </ds-segmented-control>
        </div>
    }
}
